import React from "react";
import { CheckIcon } from "lucide-react";
import { finalList, images } from "../../data/content";
import { CtaButton } from "../ui/CtaButton";
import { Countdown } from "../ui/Countdown";
export function FinalSection() {
  return <section className="bg-navydeep px-5 py-16 sm:py-24" data-id="element-90" data-mp="2haxeq3nsw4rj">
      <div className="mx-auto max-w-3xl text-center" data-id="element-91" data-mp="2cbukle9cziyc">
        <p className="text-sm font-bold uppercase tracking-[0.18em] text-cyan" data-id="element-92" data-mp="2ca9o3j3hhpxu">Ready to Organize Your Endodontic Knowledge?</p>
        <h2 className="mt-3 font-display text-[2rem] font-extrabold leading-tight text-white sm:text-5xl" data-id="element-93" data-mp="1jnouebzjd1r4">
          See How the Major Areas of Endodontics Connect
        </h2>
        <p className="mt-5 text-lg leading-relaxed text-white/80" data-id="element-94" data-mp="1yeo3rp873ubr">
          You don't necessarily need another collection of disconnected notes. You may benefit from a visual framework that
          helps you navigate the information you already have, organize your initial case review, and document the
          questions that still need attention.
        </p>

        <div className="-mx-5 mt-6 sm:mx-0" data-id="element-95" data-mp="hkplic1tq348">
          <img src={images.hero} alt="Endo Blueprint complete package" className="w-full" data-id="element-96" data-mp="mklrggu304mf" />
        </div>

        <p className="mt-4 text-left text-lg font-bold text-white sm:text-center" data-id="element-97" data-mp="rbag7oedmnhv">With Endo Blueprint™, you'll receive:</p>
        <ul className="mx-auto mt-4 grid max-w-2xl gap-x-6 gap-y-2.5 text-left sm:grid-cols-2" data-id="element-98" data-mp="vd5iav44t4wp">
          {finalList.map(f => <li key={f} className="flex gap-2.5 text-[16px] leading-snug text-white/90" data-id="element-99" data-mp="3utlpchac9rt1">
              <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-[#4ADE80]" aria-hidden="true" data-id="element-100" data-mp="3miwzmirlfh8" />
              {f}
            </li>)}
        </ul>

        <div className="mt-10 rounded-3xl bg-navy p-6 sm:p-8" data-id="element-101" data-mp="cm60cdv20vcx">
          <p className="text-sm font-extrabold uppercase tracking-wider text-white/80" data-id="element-102" data-mp="cnpd3uhi4o9y">
            Get the complete Endo Blueprint™ today
          </p>
          <p className="mt-2 font-display text-6xl font-black text-[#4ADE80] sm:text-7xl" data-id="element-103" data-mp="1o0rxl0mq1xze">
            JUST $27 <span className="text-2xl" data-id="element-104" data-mp="3k3xze47dd208">USD</span>
          </p>
          <p className="mt-2 text-sm text-white/70" data-id="element-105" data-mp="3k6k8w9dtlrl3">One-Time Payment · Instant Digital Access · 7-Day Guarantee</p>
          <div className="mt-6" data-id="element-106" data-mp="3u2n9hat0xi5x">
            <CtaButton label="Yes, I Want the Endo Blueprint™" data-id="element-107" data-mp="3u1u70m13letl" />
          </div>
          <Countdown tone="dark" data-id="element-108" data-mp="3p3ajwiarpwzn" />
        </div>
      </div>
    </section>;
}